"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StyleEnum;
(function (StyleEnum) {
    StyleEnum["CIRCLE"] = "rounded-circle";
    StyleEnum["BOXED"] = "boxed";
    StyleEnum["ROUNDED"] = "rounded";
    StyleEnum["EXTRA_ROUNDED"] = "extra-rounded";
    StyleEnum["SQUARED"] = "squared";
})(StyleEnum || (StyleEnum = {}));
exports.default = StyleEnum;
